<template>
  <div class="login-as">
    <el-tooltip class="item" effect="dark" :content="`Login as ${user.first_name} on old.syncvault.com`" placement="top">
      <i class="el-icon-sort" @click="loginAsUser"></i>
    </el-tooltip>
  </div>
</template>

<script>
import axios from '@/plugins/axios'

export default {
  props: {
    user: { type: Object, default: () => ({}) }
  },

  methods: {
    async loginAsUser() {
      try {
        const response = await axios.admin.post(`user/login-as/${this.user.id}`)

        if (response.data.access_token) {
          let domain = location.hostname.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/)

          domain = domain ? domain[1] : 'localhost'
          const secure = process.env.NODE_ENV === 'production'

          document.cookie=`admin_secret_key=${response.data.admin_secret_key};path=/;${secure ? 'Secure;' : ''}domain=${domain}`
          document.cookie=`admin_login_token=${response.data.access_token};path=/;${secure ? 'Secure;' : ''}domain=${domain}`

          window.open(`${process.env.VUE_APP_FRONT_URL}admin-login`, '_blank', 'noopener')
        }
      } catch (err) { console.log(err) }
    }
  }
}
</script>

<style scoped lang="scss">
.login-as {
  display: inline-block;
  cursor: pointer;
}
</style>